import { Button, Grid } from '@material-ui/core';
import { defer } from '@thalesrc/js-utils';
import React, { useCallback, useContext, useRef } from 'react';

import Dialog from 'Common/Dialog';
import Form, { FormRef } from 'Common/Form/Form';
import TextField from 'Common/Form/TextField';
import { AlertContext } from 'context/alert.context';
import { SelectOptionsContext } from 'context/select-options.context';
import { useAsyncEffect } from 'utils';

import { Icd10WarningLabelDto } from '../../api/client';
import { Icd10WarningLabelControllerService } from '../../api/client/services/Icd10WarningLabelControllerService';
import AutoComplete from '../../Common/Form/AutoComplete';

interface Props {
  open: boolean;
  data: Icd10WarningLabelDto;

  onClose(success: boolean): void;
}

export default function Icd10LabelsWarningForm({ open, onClose, data }: Props) {
  const formRef = useRef<FormRef<Record<string, any>>>();
  const { icd10ViewType } = useContext(SelectOptionsContext);
  const { showMessage } = useContext(AlertContext);

  const submit = useCallback(
    async values => {
      try {
        await Icd10WarningLabelControllerService.updateIcd10WarningLabel(data?.id, values);
        showMessage('Ekleme işlemi başarılı.', 'success', 'info');
        onClose(true);
      } catch (err) {
        showMessage('İşlem sırasında sorun oluştu.', 'error', 'info');
        onClose(false);
      }
    },
    [onClose, showMessage, data]
  );

  useAsyncEffect(async () => {
    if (!data) {
      return;
    }

    await defer();

    for (const [key, value] of Object.entries(data)) {
      formRef.current.methods.setValue(key, value);
    }
    formRef.current.methods.trigger();
  }, [data, open]);

  return (
    <>
      <Dialog color="primary" opened={open} onClose={onClose} title={data?.label ? ' Uyarı Düzenle' : 'Uyarı Ekle'}>
        <Form onSubmit={submit} ref={formRef}>
          <Grid container spacing={1}>
            <Grid item md={12} sm={12} lg={12}>
              <TextField required name="label" label="Uyarı" />
            </Grid>
            <AutoComplete required single name="viewType" options={icd10ViewType} label="Muayene Tipi" />
            <Grid item xs={12} md={12} lg={12} sm={12} />
            <Grid item md={12} className="text-right">
              <Button variant="contained" type="submit" color="secondary" className="mr-2">
                {data?.label ? 'Güncelle' : 'Kaydet'}
              </Button>
              <Button variant="contained" type="button" onClick={onClose.bind(null, false)}>
                Vazgeç
              </Button>
            </Grid>
          </Grid>
        </Form>
      </Dialog>
    </>
  );
}
